import { Button } from "antd";
import { useState, useEffect } from "react";
import { Loader } from "../../../UI/Loaders/Loaders";
import { appInsights } from "../../../config/appInsights";
import Paginator from "../../Pagination/Pagination.component";
import CustomSelectDropdown from "../../CustomHTMLElements/CustomSelectDropdown";
import useGetPendingAdminUnlockUsers, {
  IPendingAdminUnlockUser,
} from "./hooks/useGetPendingAdminUnlockUsers";
import UnlockRequestModal from "./components/UnlockRequestModal";

const PendingAdminUnlock = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [size, setSize] = useState(10);
  const [selectedUser, setSelectedUser] =
    useState<IPendingAdminUnlockUser | null>(null);

  useEffect(() => {
    appInsights.trackPageView({
      name: "PendingAdminUnlock.tsx",
      isLoggedIn: true,
    });
  }, []);

  const { data, status, error, refetch } = useGetPendingAdminUnlockUsers();

  let RenderedComponent = null;
  if (!data && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Users Pending Unlock
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = (
      <Loader centered={true} text="Loading Users Pending Unlock..." />
    );
  } else if (error) {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt p-y-5">
            <i className="fas fa-bell" /> There was an issue while fetching
            Users Pending Unlock. Please Reload The Page.
          </h4>
        </div>
      </div>
    );
  } else if (data && data.data.length === 0) {
    RenderedComponent = (
      <div className="centerLoader">
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt p-y-5">
            <i className="fas fa-bell" /> No users pending unlock
          </h4>
        </div>
      </div>
    );
  } else {
    RenderedComponent = (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>S/N</th>
              <th>Name</th>
              <th>Email</th>
              <th>Lock Reason</th>
              <th>Unlock Reason</th>
              <th>Workflow Code</th>
              <th>Date Initiated</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.data.map((user: IPendingAdminUnlockUser, _id: number) => (
              <tr key={user.transactionReferenceNumber}>
                <td>{_id + 1 + (pageNumber - 1) * size}</td>
                <td>{user.lockedUserName}</td>
                <td>{user.lockedUserMail}</td>
                <td>{user.lockReason}</td>
                <td>{user.unlockReason}</td>
                <td>{user.workflowCode}</td>
                <td>{user.dateInitiated.split("T")[0]}</td>
                <td>
                  <Button type="dashed" onClick={() => setSelectedUser(user)}>
                    View Details
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="datatable-wrapper">
      <div className="table-view speed-1x animated fadeInRight">
        <div className="d-flex flex-row flex-wrap justify-content-between mb-4">
          <h3 className="page-title">Users Pending Unlock</h3>
        </div>

        <div className="row">
          <div className="form-group col-md-2">
            <label>Results per page</label>
            <CustomSelectDropdown
              name="pageSize"
              onChange={(e) => {
                setSize(Number(e.target.value));
                setPageNumber(1);
              }}
              value={size}
              isShowDropdownArrow
            >
              <option value={10}>10 Entries</option>
              <option value={20}>20 Entries</option>
              <option value={50}>50 Entries</option>
              <option value={100}>100 Entries</option>
            </CustomSelectDropdown>
          </div>
        </div>

        <div>{RenderedComponent}</div>

        <Paginator
          size={size}
          page={pageNumber}
          count={data?.data?.length}
          changeCurrentPage={(pageNumber: number) => setPageNumber(pageNumber)}
        />
      </div>

      {selectedUser && (
        <UnlockRequestModal
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
          onSuccess={() => {
            setSelectedUser(null);
            refetch();
          }}
        />
      )}
    </div>
  );
};

export default PendingAdminUnlock;
